import { ProductListPage, ProductWithSpecification, Pagination, Product } from "Models/Products/ProductListPage";
import { FacetFilter, Option } from "Models/FacetFilter/FacetFilter";
import * as $ from "jquery";
import Vue from 'vue';
import Component from "vue-class-component";
import ABaseComponent from "Components/Base/ABaseComponent";
import productList from "Store/productList/productList";
import { Prop, Watch } from "vue-property-decorator";
import { Client, PorterViewModel, GetPorterItemListViewModel, PorterItemViewModel } from "Api/CoreApi";
import ApiProvider from "Api/ApiProvider";
import porterBuilder from "Store/porterbuilder/porterbuilder";
import productVariantStore from "Store/productVariantStore/productVariantStore";
import { toUpper } from "lodash";
import { Specification } from "Models/Products/ProductListPage";

@Component({})
export class SpecComponentForChangedPgc extends ABaseComponent {
    specList: string[] = null;

    @Prop()
    languageId: string;

    @Prop()
    productId: string;

    public get getSpecificationFromChangedPgc():string[] {
        return this.specList;
    }

    async beforeMount() {
        const client = ApiProvider.getApiClient();
        this.specList = await client.getProductSpecListById(this.languageId, this.productId);
    }
}
Vue.component("spec-for-changed-pgc", SpecComponentForChangedPgc)